(function($) {
    $(document).ready(function(){

        $('.gallery-carousel').owlCarousel({
            loop:true,
            margin:10,
            merge:true,
            center:true,
            lazyLoad: false,
            nav:true,
            navText:['',''],
            responsiveClass:true,
            responsive:{
                0:{
                    items:1
                },
                768:{
                    items:6
                }
            }
        });
        // There's a bug in owl carousel where the nav will stay hidden even when set to true.
        // Had to do a bit of a hack to get it to show.
        $('.gallery-carousel').find('.owl-nav').removeClass('disabled');
        $('.gallery-carousel').on('changed.owl.carousel', function(event) {
            $(this).find('.owl-nav').removeClass('disabled');
        });

        function checkClasses(){
            console.log('checking....');
            var total = $('.insta-carousel .owl-stage .owl-item.active').length;
            
            $('.insta-carousel .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');
            
            $('.insta-carousel .owl-stage .owl-item.active').each(function(index){
                if (index === 0) {
                    // this is the first one
                    $(this).addClass('firstActiveItem');
                }
                if (index === total - 1 && total>1) {
                    // this is the last one
                    $(this).addClass('lastActiveItem');
                }
            });
        }


        $('.insta-carousel').on('translated.owl.carousel initialized.owl.carousel', function(event) {
            checkClasses();
        }).owlCarousel({
            loop:true,
            margin:10,
            merge:false,
            center:false,
            lazyLoad: false,
            nav:true,
            navText:['',''],
            responsiveClass:true,
            responsive:{
                0:{ 
                    items:2
                },
                769: {
                    items:3
                },
                1025: {
                    items: 6
                }
            }
        });


        var lazy = $(".lazy").lazy({
            chainable: false,
            effect: "fadeIn",
            effectTime: 0,
            enableThrottle: true,
            throttle: 250,
            threshold: 0,
            visibleOnly: false,
            onError: function(element) {
              console.log("error loading " + element.data("src"));
            }
          });


        // There's a bug in owl carousel where the nav will stay hidden even when set to true.
        // Had to do a bit of a hack to get it to show.
        $('.insta-carousel').find('.owl-nav').removeClass('disabled');
        $('.insta-carousel').on('changed.owl.carousel', function(event) {
            lazy.update();
            $(this).find('.owl-nav').removeClass('disabled');
        });
        $('.insta-carousel').on("translated.owl.carousel", function(event) {
            lazy.update();
        });

    });
})(jQuery); // Fully reference jQuery after this point.
